export { ModalComponent } from './modal.component';
export { L_ModalModule } from './modal.module';



// WEBPACK FOOTER //
// ./.tmp/modal/index.ts